// Enkel könsgissning utifrån förnamn, för att kunna varva recensioner.

const FEMALE = new Set([
  // Svenska
  'anna','maria','margareta','elisabeth','eva','birgitta','kristina','karin','elisabet','marie',
  'ingrid','christina','sofia','linnea','kerstin','lena','helena','emma','johanna','marianne',
  'inger','sara','cecilia','elin','anita','louise','irene','iréne','ulla','viktoria','victoria',
  'susanne','malin','hanna','jenny','ida','frida','therese','teresa','camilla','carina','katarina',
  'åsa','annika','monica','gunilla','pia','petra','nina','ulrika','lotta','charlotte','charlotta',
  'josefin','josefine','matilda','moa','klara','clara','stina','ebba','alva','agnes','astrid',
  'wilma','ella','alice','olivia','julia','amanda','filippa','felicia','isabelle','isabella',
  'nathalie','natalie','rebecca','rebecka','saga','signe','siri','tuva','vera','tilda','maja',
  'linda','sandra','jessica','madeleine','veronica','yvonne','birgit','britt','barbro','gun',
  'siv','solveig','ann','anne','anette','annette','berit','bodil','doris','ellen','elsa','gerd',
  'gudrun','hillevi','ingegerd','ingela','ingeborg','iris','lisa','lisbeth','majken','mona',
  'nora','rut','rita','sonja','tove','vanja','vivianne','ylva','åse','ester','edith','greta',
  // Internationella
  'laura','sarah','sophie','marta','marta','elena','katrin','katherine','kate','lucy','emily',
  'chloe','claire','hannah','anja','katja','tanja','olga','irina','natalia','carmen','paula',
  'lucia','giulia','francesca','martina','magdalena','agnieszka','katarzyna','joanna','ewa',
]);

const MALE = new Set([
  // Svenska
  'lars','mikael','michael','anders','johan','erik','per','karl','carl','peter','thomas','tomas',
  'jan','daniel','fredrik','hans','mattias','mathias','marcus','markus','gunnar','bengt','stefan',
  'niklas','nils','bo','magnus','martin','sven','christer','kristian','christian','patrik','patrick',
  'jonas','david','joakim','robert','andreas','henrik','david','oskar','oscar','alexander','viktor',
  'victor','simon','emil','filip','philip','william','lucas','liam','hugo','elias','oliver','axel',
  'gustav','gustaf','ludvig','albin','melvin','theo','isak','arvid','olof','olle','ove','leif',
  'kjell','rolf','roger','ulf','tommy','tony','john','jonathan','jesper','joel','linus','rasmus',
  'sebastian','samuel','ted','tim','timothy','tobias','love','love','vincent','wilhelm','åke',
  'åsmund','örjan','björn','göran','håkan','jörgen','kenneth','klas','lennart','mats','morgan',
  'ronny','rune','stig','sture','torbjörn','tore','urban','vilhelm','yngve','folke','ingemar',
  // Internationella
  'james','robert','george','paul','mark','luke','matthew','andrew','antonio','marco','luca',
  'giovanni','pierre','jean','francois','miguel','javier','pablo','jose','pedro','ivan','sergei',
  'dmitri','piotr','pawel','jakub','tomasz','ahmed','mohamed','mohammed','ali','omar','hassan',
]);

export type Gender = 'female' | 'male' | 'unknown';

export function guessGender(name?: string | null): Gender {
  if (!name) return 'unknown';
  const first = name.trim().split(/\s+/)[0]?.toLowerCase().replace(/[^a-zà-ÿåäö-]/g, '');
  if (!first) return 'unknown';
  if (FEMALE.has(first)) return 'female';
  if (MALE.has(first)) return 'male';
  // Vanliga svenska ändelser som starkt indikerar kvinnonamn
  if (/(?:a|ina|ika|itta|else)$/.test(first) && !MALE.has(first)) return 'female';
  return 'unknown';
}

/**
 * Varvar recensioner: kvinna, man, kvinna, man ...
 * Behåller inbördes ordning inom varje grupp. Okända läggs sist.
 */
export function interleaveByGender<T extends { author_name?: string | null }>(items: T[]): T[] {
  const female: T[] = [];
  const male: T[] = [];
  const unknown: T[] = [];

  items.forEach((item) => {
    const g = guessGender(item.author_name);
    if (g === 'female') female.push(item);
    else if (g === 'male') male.push(item);
    else unknown.push(item);
  });

  const result: T[] = [];
  const max = Math.max(female.length, male.length);
  for (let i = 0; i < max; i++) {
    if (female[i]) result.push(female[i]);
    if (male[i]) result.push(male[i]);
  }
  return [...result, ...unknown];
}
